import { render, staticRenderFns } from "./ONavTop.vue?vue&type=template&id=1ef0c9c0"
import script from "./ONavTop.vue?vue&type=script&lang=js"
export * from "./ONavTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports